import Component from 'components/component'
import { Link } from 'components/link'
import ShareView from 'components/share/view'
import Tooltip from 'components/tooltip'
import * as routes from 'config/routes'
import { DI } from 'modules'
import React, { Fragment } from 'react'

export class LiveDescription extends Component {
  getImgUrl(size) {
    const liveEvent = this.props.liveEvent

    const img = liveEvent.image

    return (img[size] && img[size].url) || img.url
  }

  render() {
    const liveEvent = this.props.liveEvent
    const { strings } = this.props.common

    return (
      <div className="live-description">
        <div className="live-description__head">
          <ShareView
            titleOfStr={'page.lives.view.share'}
            entity={{
              id: liveEvent.id,
              title: liveEvent.title,
              desc: liveEvent.description,
              img: this.getImgUrl('v960x540'),
            }}
            alignLeft
          />
          {liveEvent.limit_type === 'pool' && (
            <div className="live-mark-container">
              <span className="live__mark">
                {'Pool '}
                {strings['page.lives.view.pool_description']}
              </span>
              <Tooltip content={strings[`page.video.left.pool.info`]}>
                <span className="question" />
              </Tooltip>
            </div>
          )}
          {liveEvent.free_access && (
            <div className="live-mark-container">
              <span className="live__mark">
                {strings['project_card.bage.free.label']} {strings['project_card.bage.free.text']}
              </span>
              <Tooltip content={strings[`page.video.slider.is_free_content`]}>
                <span className="question" />
              </Tooltip>
            </div>
          )}
        </div>

        <h1 className="live__title">
          <Fragment>
            {liveEvent.clients_only && (
              <Tooltip content={strings['page.lives.view.clients_only']}>
                <span className="live__only-clients" />
              </Tooltip>
            )}

            {liveEvent.title}
          </Fragment>
        </h1>
        <div className="live-place">
          <span className="live__place">
            {[liveEvent.country_name, liveEvent.location].join(', ')}
          </span>
        </div>
        <LiveTags tags={liveEvent.tags} />
        {liveEvent.description && (
          <div className="live-desc">
            {liveEvent.description.split(/\n/g).map((text, index) => (
              <p key={index}>{text}</p>
            ))}
          </div>
        )}
      </div>
    )
  }
}

function LiveTags({ tags = [] }) {
  if (!tags.length) {
    return null
  }
  return (
    <div className="live-tags">
      {tags.map((tag, index) => (
        <Link to={routes.landing.getPath(null, tag.slug)} className="live__tag" key={tag.id}>
          {String(tag.name)}
        </Link>
      ))}
    </div>
  )
}

export default DI(['common'])(LiveDescription)
